import { render, staticRenderFns } from "./CreateRole.vue?vue&type=template&id=50a90426&scoped=true&"
import script from "./CreateRole.vue?vue&type=script&lang=js&"
export * from "./CreateRole.vue?vue&type=script&lang=js&"
import style0 from "./CreateRole.vue?vue&type=style&index=0&id=50a90426&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a90426",
  null
  
)

export default component.exports